export { default } from './ScrollTopButton.js';
